// Fires a single Purchase / CompletePayment conversion event across Meta Pixel,
// TikTok Pixel and GTM/GA4 for a paid order. Uses sessionStorage to avoid
// double-firing when the user refreshes the order detail page or the poll
// transitions to `paid` after the initial paid render.
export function firePurchasePixel(orderId: string, amount: number, currency: string = 'IDR'): void {
  if (typeof window === 'undefined' || !orderId) return;
  const key = `pixel_purchase_${orderId}`;
  try {
    if (window.sessionStorage.getItem(key)) return;
    window.sessionStorage.setItem(key, '1');
  } catch {
    // ignore storage errors — worst case we double-fire, which is safe for ROAS.
  }
  const value = Number(amount) || 0;
  try {
    const w: any = window;
    if (typeof w.fbq === 'function') {
      w.fbq('track', 'Purchase', { value, currency, content_ids: [orderId], content_type: 'product' });
    }
    if (w.ttq && typeof w.ttq.track === 'function') {
      w.ttq.track('CompletePayment', { value, currency, content_id: orderId, content_type: 'product' });
    }
    if (Array.isArray(w.dataLayer)) {
      w.dataLayer.push({ event: 'purchase', ecommerce: { transaction_id: orderId, value, currency } });
    }
  } catch {
    /* pixel errors must never break UX */
  }
}
